import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Dashboard pages
export const DashboardPage = lazy(
  () =>
    retry(() => import('@/pages/dashboard/dashboard')) as Promise<
      typeof import('@/pages/dashboard/dashboard')
    >
);
